import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { UseCasesDataRequestPayloadTypes } from '../models/use-cases';

const BuildUseCaseService = {
  fetchAllUseCasesList: async (payload?: UseCasesDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.BUILD_USE_CASE_BASE_URL, { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchUseCase: async (useCaseId: string) => {
    try {
      // const res = await axiosClient.get(url);
      const flowData = [
        {
          id: 'cloud',
          type: 'cloudNode',
        },
        {
          id: 'edge',
          type: 'edgeNode',
          data: {
            options: [
              { id: 'addComponent', label: 'Add Component' },
              { id: 'businessRules', label: 'Business Rules' },
            ],
            label: 'Kharadi Room',
          },
        },
        {
          id: 'asjak',
          type: 'assetNode',
          data: {
            label: 'Asset Hello',
            address: '192.1.1.18',
            options: [
              {
                id: 'opc',
                label: 'OPC',
                type: 'opc',
                name: 'Screwing Line Controller',
                address: 'opc.tcp://172.17.0.3:4840/opc',
                data: {
                  props: [
                    { dashboard: true, displayName: 'OPC Kharadi', name: 'India', id: 'ns=2:ssss', uom: 'Running' },
                    { dashboard: false, displayName: 'BNAS', name: 'India', id: 'ns=2:kkkk', uom: 'Running' },
                  ],
                },
              },
              {
                id: 'modbus',
                label: 'MODBUS',
                type: 'modbus',
                name: 'Screwing Line Controller',
                address: 'opc.tcp://172.17.0.3:4840/modbus',
                data: {
                  props: [
                    { dashboard: true, displayName: 'MODBUS Kharadi', name: 'India', id: 'ns=2:ssss', uom: 'Running' },
                    { dashboard: false, displayName: 'BNAS', name: 'India', id: 'ns=2:kkkk', uom: 'Running' },
                  ],
                },
              },
            ],
            // options: ['OPC', 'MODBUS---'],
            // props: [
            //   { dashboard: true, displayName: 'Kharadi', name: 'India', id: 'ns=2:ssss', uom: 'Running' },
            //   { dashboard: false, displayName: 'BNAS', name: 'India', id: 'ns=2:kkkk', uom: 'Running' },
            // ],
          },
          extent: 'parent',
        },
        {
          id: 'abcd',
          type: 'assetNode',
          data: {
            label: 'Asset 2',
            address: '192.1.1.19',
            options: [
              {
                id: 'sql',
                label: 'SQL',
                type: 'sql',
                name: 'Screwing Line Controller',
                address: 'opc.tcp://172.17.0.3:4840/sql',
                data: {
                  props: [
                    { dashboard: true, displayName: 'MODBUS Kharadi', name: 'India', id: 'ns=2:ssss', uom: 'Running' },
                    { dashboard: false, displayName: 'BNAS', name: 'India', id: 'ns=2:kkkk', uom: 'Running' },
                  ],
                },
              },
            ],
            // options: ['SQL'],
          },
        },
        {
          id: 'machine',
          type: 'machineNode',
          data: {
            label: 'Screwing Machine',
            options: [
              {
                id: 'opc',
                label: 'OPC',
                type: 'opc',
                name: 'Screwing Line Controller',
                address: 'opc.tcp://172.17.0.3:4840/opc',
                data: [
                  { id: 1, dashboard: true, displayName: 'OPC Lic', useBy: 'Unused' },
                  { id: 2, dashboard: false, displayName: 'Remote St', useBy: 'Unused' },
                  { id: 3, dashboard: true, displayName: 'Compressor', useBy: 'Unused' },
                  { id: 4, dashboard: true, displayName: 'Leaving CL', useBy: 'Unused' },
                ],
              },
              {
                id: 'modbus',
                label: 'MODBUS',
                type: 'modbus',
                name: 'Screwing Line Controller',
                address: 'opc.tcp://172.17.0.3:4840/modbus',
                data: [
                  { id: 1, dashboard: true, displayName: 'MODBUS Lic', useBy: 'Unused' },
                  { id: 2, dashboard: false, displayName: 'Remote St', useBy: 'Unused' },
                  { id: 3, dashboard: true, displayName: 'Compressor', useBy: 'Unused' },
                  { id: 4, dashboard: true, displayName: 'Leaving CL', useBy: 'Unused' },
                ],
              },
            ],
          },
        },
      ];

      const data = [
        {
          id: '1',
          displayName: 'Kharadi Plant',
          totalEgs: '1',
          configuredEgs: '1',
          notConfiguredEgs: '0',
          deployedEgs: '1',
          rooms: [
            { id: 1, displayName: 'Kharadi Room 1', location: 'India/Maharashtra/Pune/Kharadi', status: 'Running' },
          ],
          flowData,
        },
        {
          id: '2',
          displayName: 'Hinjewadi Plant',
          totalEgs: '1',
          configuredEgs: '1',
          notConfiguredEgs: '0',
          deployedEgs: '0',
          rooms: [
            { id: 1, displayName: 'Hinjewadi Room 1', location: 'India/Maharashtra/Pune/Hinjewadi', status: 'Running' },
          ],
          flowData,
        },
        {
          id: '3',
          displayName: 'Chakan Plant',
          totalEgs: '2',
          configuredEgs: '1',
          notConfiguredEgs: '0',
          deployedEgs: '1',
          rooms: [
            { id: 1, displayName: 'Chakan Room 1', location: 'India/Maharashtra/Pune/Chakan', status: 'Running' },
          ],
          flowData,
        },
        {
          id: '4',
          displayName: 'Wakad Plant',
          totalEgs: '2',
          configuredEgs: '1',
          notConfiguredEgs: '1',
          deployedEgs: '0',
          rooms: [{ id: 1, displayName: 'Wakad Room 1', location: 'India/Maharashtra/Pune/Wakad', status: 'Running' }],
          flowData,
        },
      ];

      const res = data.find((item) => item.id === useCaseId);

      // console.log(res, useCaseId, 'res');

      return {
        status: 'success',
        res,
      };
    } catch (error) {
      return {
        status: 'error',
        error,
      };
    }
  },
  fetchUseCaseById: async (payload: any) => {
    // const url = `/check_token/${token}`;
    try {
      const apiResponse: any = await axiosClient.get(apiPath.BUILD_USE_CASE_BASE_URL + '/' + payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addNewUseCase: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.BUILD_USE_CASE_BASE_URL, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateUseCase: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(apiPath.BUILD_USE_CASE_BASE_URL + '/' + payload.id, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateUseCaseStatus: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(apiPath.BUILD_USE_CASE_BASE_URL, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deployUseCase: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.put(apiPath.BUILD_USE_CASE_BASE_URL + '/' + payload.id);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  removeUseCase: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.delete(apiPath.BUILD_USE_CASE_BASE_URL + '/' + payload.use_case_id);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default BuildUseCaseService;
